import germanLocals from 'date-fns/locale/de';
import createFormatDate from '@utils/createFormatDate';

export default createFormatDate(germanLocals);